export const VIEW_MORE_STYLE = {
  LINK: 'LINK',
  BUTTON: 'BUTTON'
}

export const CLASS_BY_VIEW_MORE_STYLE = {
  [VIEW_MORE_STYLE.LINK]: 'a-view-more__link',
  [VIEW_MORE_STYLE.BUTTON]: 'a-view-more__button'
}
